<template>
    <div class="lang-switcher d-flex align-items-center gap-1">
        <button
            v-for="lang in langs"
            :key="lang.code"
            @click="setLocale(lang.code)"
            :class="['btn btn-sm lang-btn', locale === lang.code ? 'active' : '']"
            :title="lang.label"
        >
            <span :class="`fi fi-${lang.flag}`"></span>
        </button>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { setLocale } from '@/i18n';

const { locale } = useI18n();

const langs = [
    { code: 'fr', label: 'Français', flag: 'fr' },
    { code: 'en', label: 'English', flag: 'gb' },
    { code: 'it', label: 'Italiano', flag: 'it' },
    { code: 'es', label: 'Español', flag: 'es' },
    { code: 'de', label: 'Deutsch', flag: 'de' },
    { code: 'nl', label: 'Nederlands', flag: 'nl' },
    { code: 'pt', label: 'Português', flag: 'pt' },
    { code: 'co', label: 'Corsu', flag: 'corsu' },
];

</script>

<style scoped>
.lang-btn {
    background: transparent;
    border: 1px solid transparent;
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 1.1rem;
    line-height: 1;
    opacity: 0.5;
    transition: opacity 0.15s, border-color 0.15s;
    cursor: pointer;
}
.lang-btn:hover {
    opacity: 0.8;
}
.lang-btn.active {
    opacity: 1;
    border-color: rgba(255, 255, 255, 0.4);
}
</style>
